import type { IconBaseProps } from "./Icon";

// TODO: rename this after removed usage of CheckIcon

export default function CheckIcon2({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Check Outline</title>
      <path
        d="M10.0502 15.15L18.5252 6.675C18.7252 6.475 18.9585 6.375 19.2252 6.375C19.4918 6.375 19.7252 6.475 19.9252 6.675C20.1252 6.875 20.2252 7.11267 20.2252 7.388C20.2252 7.66333 20.1252 7.90067 19.9252 8.1L10.7502 17.3C10.5502 17.5 10.3168 17.6 10.0502 17.6C9.78351 17.6 9.55018 17.5 9.35018 17.3L5.05018 13C4.85018 12.8 4.75418 12.5627 4.76218 12.288C4.77018 12.0133 4.87451 11.7757 5.07518 11.575C5.27585 11.3743 5.51351 11.2743 5.78818 11.275C6.06285 11.2757 6.30018 11.3757 6.50018 11.575L10.0502 15.15Z"
        fill="currentColor"
      />
    </svg>
  );
}
